module.exports = __webpack_public_path__ + "img/myposition_wm_데이비드 베컴.e9c83b08.png";